// extracted by mini-css-extract-plugin
export default {"display":"Loading_display__nMEUl","display-none":"Loading_display-none__crioc"};